import { apiService, Endpoints } from "api";

export const removeBusinessUnit =
  (companyId: number) => async (unitId: number) =>
    await apiService.delete(
      Endpoints.Companies.Delete.BusinessUnit(companyId, unitId)
    );
